// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5499":"9fa000cc","8358":"9fa000cc"}[chunkId] + ".chunk.css";
};